import { render, staticRenderFns } from "./InitialSelectSecurityMethod.vue?vue&type=template&id=2f0122e9&"
import script from "./InitialSelectSecurityMethod.vue?vue&type=script&lang=js&"
export * from "./InitialSelectSecurityMethod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports